import React, { Component } from 'react';
import { SelectBox } from 'devextreme-react/select-box';
import { getRequestParams } from '../../helpers/globalfunctions';


export class VehicleDriverComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            driversDropdownList: [],
            vehiclesDropdownList: [],
            filterDriverId: 0,
            filterVehicleId: 0,
        }
    }

    async componentDidMount() {
        await this.getDriversDropdownList();
        await this.getVehiclesDropdownList();
    }

    getDriversDropdownList = async () => {
        try {
            const raw = sessionStorage.getItem("session_drivers");
            const cached = raw ? JSON.parse(raw) : null;
            let drivers = null;

            if (cached) {
                drivers = cached.driversDropdownList || cached.DriversDropdownList ||
                    (cached.data && (cached.data.driversDropdownList || cached.data.DriversDropdownList)) ||
                    (cached.data && Array.isArray(cached.data) ? cached.data : null) ||
                    (Array.isArray(cached) ? cached : null);
            }

            if (drivers === null) {
                const requestParams = getRequestParams('GET', {});
                const response = await fetch('/driver-api/dropdown-all/', requestParams);
                const data = await response.json();
                drivers = data && (data.driversDropdownList || data.DriversDropdownList || data);
                sessionStorage.setItem("session_drivers", JSON.stringify(data != null ? data : []));
            }

            this.setState({
                driversDropdownList: drivers || []
            });
        } catch (ex) {
            console.log(ex);
        }
    }
    getVehiclesDropdownList = async () => {
        try {
            const raw = sessionStorage.getItem("session_vehicles");
            const cached = raw ? JSON.parse(raw) : null;
            let vehicles = null;

            if (cached) {
                vehicles = cached.vehiclesDropdown || cached.VehiclesDropdown ||
                    (cached.data && (cached.data.vehiclesDropdown || cached.data.VehiclesDropdown)) ||
                    (cached.data && Array.isArray(cached.data) ? cached.data : null) ||
                    (Array.isArray(cached) ? cached : null);
            }

            if (vehicles === null) {
                const requestParams = getRequestParams('GET', {});
                const response = await fetch('/vehicle-api/dropdown-all', requestParams);
                const data = await response.json();
                vehicles = data && (data.vehiclesDropdown || data.VehiclesDropdown || data);
                sessionStorage.setItem("session_vehicles", JSON.stringify(data != null ? data : []));
            }

            this.setState({
                vehiclesDropdownList: vehicles || []
            });
        } catch (ex) {
            console.log(ex);
        }
    }

    handleFilterDriverOnChange = (selectedOption) => {
        this.setState({ filterDriverId: (selectedOption.selectedItem ? selectedOption.selectedItem.id : 0) })
    }
    handleFilterVehicleOnChange = (selectedOption) => {
        this.setState({ filterVehicleId: (selectedOption.selectedItem ? selectedOption.selectedItem.id : 0) })
    }

    render() {
        return (
            <React.Fragment>
                <div className="rx-fg">
                    <label>Driver</label>
                    <SelectBox
                        dataSource={this.state.driversDropdownList}
                        placeholder="Select driver"
                        name="id"
                        value={this.state.filterDriverId || null}
                        displayExpr='name'
                        valueExpr='id'
                        onSelectionChanged={this.handleFilterDriverOnChange}
                        showClearButton={true}
                        disabled={false}
                        searchEnabled={true}
                    />
                </div>
                <div className="rx-fg">
                    <label>Vehicle</label>
                    <SelectBox
                        dataSource={this.state.vehiclesDropdownList}
                        placeholder="Select vehicle"
                        name="id"
                        value={this.state.filterVehicleId || null}
                        displayExpr='name'
                        valueExpr='id'
                        onSelectionChanged={this.handleFilterVehicleOnChange}
                        showClearButton={true}
                        disabled={false}
                        searchEnabled={true}
                    />
                </div>
            </React.Fragment>
        );
    }
}